import client from './apiClient';
import { Utils } from 'ecrion-components';

const localStorageKey = 'ECR.EOS.AccessToken';

const handleUserError = (error) => {
  if (!error || !error.response || !error.response.header) throw error;

  const ecrForceRedirect = error.response.header['ecr_force_redirect'];
  if (!ecrForceRedirect) throw error;

  window.location.href = ecrForceRedirect;
};

function getUser() {
  return client('portaluserproperties').catch((error) => {
    logout();
    return Promise.reject(error);
  });
}

function login({ environment, username, password }) {
  const headers = {
    Authorization: 'Basic ' + btoa(`${environment}:${username}:${password}`),
  };

  return Utils.request({
    method: 'GET',
    url: `${process.env.REACT_APP_WEBSITE_URL}/backend/portalToken`,
    headers: headers,
  }).then(() => {}, handleUserError);
}

function logout() {
  return client(`portalToken`, {
    method: 'DELETE',
  }).then(
    (logoutRedirect) => {
      window.localStorage.removeItem(localStorageKey);
      return logoutRedirect;
    },
    () => {
      window.localStorage.removeItem(localStorageKey);
    }
  );
}

export { login, logout, getUser };
